<template>
    <div id="lightboxCarouselCustom" class="lightbox__container" :class="{ 'lightbox__container-active': lightbox }">
        <div class="lightbox__content text-center">
            <!-- <img class="lightbox-img"
                src="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/tres-marias/img/imgPaseoDelParque/Torres/amenitiesTorrePPCasa.png"
                alt=""> -->
            <div :id="idLightbox" style="height: 100%;width: 100%;" class="carousel slide " data-bs-touch="false">
                <div class="carousel-inner"
                    style="width: 100%;overflow-x: hidden;height: 100%;display: flex;align-items: center;">
                    <div class="carousel-item" v-for="(element, index) in elements" :key="index" :class="element.class"
                        style="height: 100%;width: 100%;">
                        <div class="lightbox-content__img" style="height: 100%;width: 100%;">
                            <img :src="element.src" class="d-block lightbox-img" alt="...">
                        </div>
                    </div>
                </div>
                <button v-show="numShow != 0" @click="titlePrev()" class="carousel-control-prev" type="button"
                    :data-bs-target="`#${idLightbox}`" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path>
                        </svg>
                    </span>
                    <span class="visually-hidden">prev</span>
                </button>
                <button v-show="numShow != elements.length - 1" @click="titleNext()" class="carousel-control-next"
                    type="button" :data-bs-target="`#${idLightbox}`" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path>
                        </svg>
                    </span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
        <div class="lightbox-tool-bar">
            <button class="lightbox-tool-bar__btn" @click="close()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                        d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z">
                    </path>
                </svg>
            </button>
        </div>
        <div class="lightbox-caption">
            <h6>{{ title }}</h6>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LightBox',
    props: ['openLightBox', "nameLightbox", "items"],
    data() {
        return {
            //title to show
            numShow: 0,
            titleShow: "",
            formatLightbox: [
                {
                    title: "",
                    src: "",
                    class: "",
                    aria: null,
                }
            ]
        }
    },
    computed: {
        lightbox() {
            if (this.openLightBox) {
                this.customBodyHTML();
            }
            return this.openLightBox
        },
        elements() {
            const newArr = this.items
            if (newArr[0]) {
                //if (typeof newArr[0] === "object") { 
                newArr.forEach(element => {
                    element.class = ''
                    element.aria = null
                });
                newArr[0].class = 'active'
                newArr[0].aria = true
                return newArr
                //} else {
                /* let convertObj = []
                newArr.forEach(element => {
                    convertObj.push(
                        {
                            src:element,
                            title:"",
                            class : '',
                            aria : null,
                        }
                    )
                });
                convertObj[0].class="active";
                convertObj[0].aria = true;
                return convertObj */
                //}  
            } else {
                return this.formatLightbox
            }

        },
        title() {
            return this.titleShow
        },
        idLightbox() {
            return this.nameLightbox
        }
    },
    methods: {
        close() {
            /*   */
            this.restartCarousel();
            this.showDefaultTitle();
            this.defaultBodyHTML();
            this.$emit('closeLightBox');
        },
        showDefaultTitle() {
            this.numShow = 0;
            this.titleShow = this.elements[this.numShow].title
        },
        titleNext() {
            let num = this.elements.length
            this.numShow++

            if (this.numShow != num) {
                this.titleShow = this.elements[this.numShow].title
            } else {
                this.numShow = 0
                this.titleShow = this.elements[this.numShow].title
            }
        },
        titlePrev() {
            this.numShow--
            this.titleShow = this.elements[this.numShow].title
        },
        restartCarousel() {
            let elements = document.querySelectorAll(`#${this.idLightbox} .carousel-inner .carousel-item`)
            elements.forEach(element => {
                element.classList.remove('active');
            });
            elements[0].classList.add('active');
        },
        customBodyHTML() {
            let body = document.querySelector("html")
            body.classList.add('quit-scrollbar-lightbox')
        },
        defaultBodyHTML() {
            let body = document.querySelector("html")
            body.classList.remove('quit-scrollbar-lightbox')
        }

    },
    mounted() {
        this.showDefaultTitle();
    },
}
</script>
<style>
#lightboxCarouselCustom button {
    width: auto !important;
    z-index: 9999;
}



#lightboxCarouselCustom svg path {
    fill: black
}

#lightboxCarouselCustom .carousel-control-prev span {
    width: 32px !important;
    height: 32px !important;
    padding: 3px;
    display: flex;
    background: white !important;
    border: 1px solid black;
}

#lightboxCarouselCustom .carousel-control-next span {
    width: 32px !important;
    height: 32px !important;
    padding: 3px;
    display: flex;
    background: white !important;
    border: 1px solid black;
}

.quit-scrollbar-lightbox {
    margin-right: 0px;
    overflow: hidden;
}
</style>
<style scoped>
.lightbox__container {
    position: fixed;
    left: 0;
    bottom: 0;
    top: 0;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    right: 0;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    opacity: 0;
    visibility: hidden;
    transition: 0.2s;
}

.lightbox__container.lightbox__container-active {
    z-index: 9999;
    background-color: rgba(30, 30, 30, 0.9);
    opacity: 1;
    visibility: visible;
    transition: 0.2s;
}

.lightbox__content {
    padding: 60px 0;
    padding-bottom: 72px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    -webkit-transition: none;
    transition: none;
    width: 100%;
    height: 100%;
}

.lightbox-content__img {
    display: flex;
}

.lightbox-img {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    z-index: 9999;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-box-shadow: 0 0 1.5rem rgba(0, 0, 0, .45);
    box-shadow: 0 0 1.5rem rgba(0, 0, 0, .45);
}

.lightbox-tool-bar {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    visibility: visible;

}

.lightbox-tool-bar__btn {
    background: rgba(255, 255, 255, 0.6);
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    cursor: pointer;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    margin: 0;
    padding: 9px;
    position: relative;
    -webkit-transition: color .2s;
    transition: color .2s;
    vertical-align: top;
    visibility: inherit;
    width: 40px;
    height: 40px;
    color: black;
    border: 1px solid black;

}

.lightbox-tool-bar__btn:hover {
    color: black;
    background: rgb(255, 255, 255);
}

.lightbox-tool-bar__btn>svg {
    width: 100%;
    height: 100%;
    opacity: 0.7;
    transition: 0.2s;
}

.lightbox-tool-bar__btn>svg:hover {
    opacity: 1;
}

.lightbox-tool-bar__btn>svg path {
    fill: black;
}

.lightbox-caption {
    bottom: 0;
    color: #eee;
    font-size: 14px;
    font-weight: 400;
    left: 0;
    opacity: 1;
    line-height: 1.5;
    padding: 18px 28px 16px 24px;
    right: 0;
    text-align: center;
    direction: ltr;
    position: absolute;
    -webkit-transition: opacity .25s ease, visibility 0s ease .25s;
    transition: opacity .25s ease, visibility 0s ease .25s;
    z-index: 99997;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, rgba(0, 0, 0, .75)), color-stop(50%, rgba(0, 0, 0, .3)), color-stop(65%, rgba(0, 0, 0, .15)), color-stop(75.5%, rgba(0, 0, 0, .075)), color-stop(82.85%, rgba(0, 0, 0, .037)), color-stop(88%, rgba(0, 0, 0, .019)), to(transparent));
    background: linear-gradient(0deg, rgba(0, 0, 0, .75), rgba(0, 0, 0, .3) 50%, rgba(0, 0, 0, .15) 65%, rgba(0, 0, 0, .075) 75.5%, rgba(0, 0, 0, .037) 82.85%, rgba(0, 0, 0, .019) 88%, transparent);
}

.lightbox-caption h6 {
    font-size: 14px;
    margin: 0 0 6px;
    line-height: 130%;
}

@media(min-width:767px) {
    .lightbox-caption {
        padding: 22px 30px 23px;
    }

    .lightbox-caption h6 {
        font-size: 16px;
        margin: 0 0 6px;
    }
}
</style>